<template>
  <div class="csv-preview">
    <v-card class="preview-card" elevation="2">
      <v-card-text>
        <div class="preview-header">
          <div class="preview-info">
            <v-icon color="primary" class="mr-2">mdi-file-eye-outline</v-icon>
            <span class="preview-title">Vista previa del archivo</span>
          </div>
          <v-chip color="success" variant="tonal" size="small">
            {{ totalRows }} registro(s) válido(s)
          </v-chip>
        </div>

        <v-divider class="my-4"></v-divider>

        <div class="preview-table-wrapper">
          <table class="preview-table">
            <thead>
              <tr>
                <th class="row-number">#</th>
                <th>Nombre</th>
                <th>Correo</th>
                <th>Rol</th>
                <th>Grupo Principal</th>
                <th>Grupos Secundarios</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in previewData" :key="index">
                <td class="row-number">{{ index + 1 }}</td>
                <td>{{ row.name }}</td>
                <td>{{ row.email }}</td>
                <td>
                  <v-chip :color="getRoleColor(row.role)" size="x-small" variant="tonal">
                    {{ row.role }}
                  </v-chip>
                </td>
                <td>{{ row.group_id || '-' }}</td>
                <td>{{ formatGroupIds(row.secondary_group_ids) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="totalRows > 10" class="preview-note mt-3">
          <v-icon size="small" color="warning" class="mr-1">mdi-information</v-icon>
          Mostrando las primeras {{ Math.min(totalRows, 10) }} filas de {{ totalRows }} registros.
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  previewResult: { type: Object, default: null },
})

const previewData = computed(() => {
  return props.previewResult?.data?.rows || []
})

const totalRows = computed(() => {
  return props.previewResult?.data?.total_rows || 0
})

const getRoleColor = (role) => {
  const colors = { ADMINISTRADOR: 'error', PROFESOR: 'warning', ESTUDIANTE: 'primary' }
  return colors[role] || 'grey'
}

const formatGroupIds = (ids) => {
  if (!ids || ids.length === 0) return '-'
  return ids.join(', ')
}
</script>

<style scoped>
.preview-card {
  border-radius: 16px !important;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.preview-info {
  display: flex;
  align-items: center;
}

.preview-title {
  font-weight: 600;
  color: #0a192f;
  font-size: 1.1rem;
}

.preview-table-wrapper {
  overflow-x: auto;
}

.preview-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.preview-table th {
  background: #f8fafc;
  color: #475569;
  font-weight: 600;
  padding: 10px 12px;
  text-align: left;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.preview-table td {
  padding: 10px 12px;
  border-bottom: 1px solid #f1f5f9;
  color: #1e293b;
}

.preview-table tr:hover td {
  background: #f8fafc;
}

.row-number {
  width: 40px;
  color: #94a3b8;
  text-align: center;
}

.preview-note {
  color: #64748b;
  font-size: 0.85rem;
  display: flex;
  align-items: center;
}
</style>
